import { EventEmitter } from './event-emitter';

type TimerEvents = 'expiring';

export class Timer extends EventEmitter<TimerEvents> {
  private timeoutId = 0;
  private interval = 0;
  private expirationDate: Date = new Date();
  private skew = 90;

  constructor() {
    super(['expiring']);
  }

  start(interval: number, expirationDate: Date, skew: number) {
    this.expirationDate = expirationDate;
    this.interval = interval;
    this.skew = skew;

    this.checkLoop();
  }

  private stop() {
    window.clearTimeout(this.timeoutId);
  }

  private checkLoop() {
    if (this.expiring()) {
      this.stop();
      this.emit('expiring');
    } else {
      this.timeoutId = window.setTimeout(() => this.checkLoop(), this.interval);
    }
  }

  private expiring() {
    const compare = addSeconds(this.skew);
    return this.expirationDate < compare;
  }
}

export function addSeconds(seconds: number | string) {
  const _seconds = Number(seconds);

  const newDate = new Date();
  newDate.setSeconds(newDate.getSeconds() + _seconds);
  return newDate;
}
